import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import ComponentTable from '../../../Components/Table/Index';
import { Column } from '../../../Components/Table/Types';
import * as Icon from '@mui/icons-material/';
import { useNavigate } from 'react-router-dom';
import { Form, Formik, Field } from 'formik';
import { UnidadeMedidaAtualizar, UnidadeMedidaCadastrar } from '../../../../routes/RoutesNames';
import { IconButton } from '@mui/material';
import { useSelector } from 'react-redux';
import UnidadeMedidaController from '../../../../controllers/UnidadeMedidaController';
import { toast } from 'react-toastify';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { Button } from '../../../../shared/components/button/Button';
import { ButtonMenu } from '../../../../shared/components/ButtonMenu'

interface Row {
  BtnEditar?: JSX.Element;
  BtnExcluir?: JSX.Element;
  unm_id: number;
  unm_descricao: string;
}

export default function UnidadeMedida() {
  const userId = useSelector((state: any) => state.Authentication.userId);
  const navigate = useNavigate();
  const tableColumns: Column[] = [
    { id: 'Id', label: 'Id', minWidth: 0 },
    { id: 'Descricao', label: 'Descrição', minWidth: 0 },
    { id: 'BtnMenu', label: '', width: 60, minWidth: 0, align: 'right' }
  ];
  const initialValues = {
    UnidadeMedidaId: null,
    Descricao: '',
  };
  const [tableRows, setTableRows] = useState<Row[]>([]);

  const handleNavigation = async (): Promise<void> => {
    navigate(UnidadeMedidaCadastrar);
  };

  const handleEditItem = (item: Row, duploClick = false, duploClickId = 0) => {
    if (duploClick) {
      navigate(UnidadeMedidaAtualizar.replace(':id', duploClickId.toString()), { state: { duploClick: true } });
    }
    else {
      navigate(UnidadeMedidaAtualizar.replace(':id', item.unm_id.toString()));
    }
  };

  const handleSubmit = async (values: any) => {
    const DataRows: any = [];
    const Response = await UnidadeMedidaController.Listar(values);

    if (Response.StatusCode === 200 && Response?.Data?.length > 0) {
      Response.Data.map((item: Row) => {
        DataRows.push({
          Id: item.unm_id,
          Descricao: item.unm_descricao,
          BtnMenu: (
            <ButtonMenu
              items={[
                { onClick: () => handleEditItem(item), menu: "Editar" },
                { onClick: () => handleDeleteItem(item.unm_id), menu: "Excluir", confirmar: `Excluir a unidade de medida "${item.unm_descricao ?? ''}"? Esta ação não pode ser desfeita.` },
              ]}
            />
          ),
        });

        setTableRows(DataRows);
      });
    } else if (Response.StatusCode === 204 && Response?.Data?.length === 0) {
      toast('Não há registros cadastrados.', {
        type: 'warning',
      });
    } else {
      toast(Response?.Data, {
        type: 'success',
      });
    }
  };

  const handleDeleteItem = async (unm_id: number) => {
    const request: any = { UsuId: userId, UnidadeMedidaId: unm_id };
    const response = await UnidadeMedidaController.Excluir(request);

    if (response.StatusCode === 204) {
      toast('Unidade de medida excluído com sucesso!', {
        type: 'success',
      });
      handleSubmit(initialValues);
    } else {
      toast('Erro ao excluir o unidade de medida!', {
        type: 'error',
      });
    }
  };

  useEffect(() => {
    handleSubmit(initialValues);
  }, []);

  return (
    <Box
      sx={{
        '& .MuiTextField-root': { m: 1 },
      }}
    >
      <div className={'pb-2'}>
        <HeaderComponent
          className={'mb-6'}
          text={'Unidade Medidas'}
          ButtonRight={
            <Button
              className={''}
              variant='success'
              onClick={handleNavigation}
              iconStart={<Icon.Add />}
              title={'Incluir'}
            />
          }
        />
        <Box mb={2} />

        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
        >
          {({ errors }) => (
            <Form className={'grid grid-cols-12 gap-2'}>
              <Field
                className={'col-span-2'}
                name='UnidadeMedidaId'
                as={TextField}
                id='outlined-password-input'
                label='Código'
                type='number'
                autoComplete='current-password'
              />
              <Field
                className={'col-span-3'}
                name='Descricao'
                as={TextField}
                label='Descricao'
                type='text'
                error={Boolean(errors?.Descricao)}
                helperText={errors?.Descricao}
              />
              <Box className={'pt-3'}>
                <IconButton size={'large'} type={'submit'}>
                  <Icon.Search style={{ fontSize: '28px' }} />
                </IconButton>
              </Box>
            </Form>
          )}
        </Formik>
      </div>
      <ComponentTable columns={tableColumns} rows={tableRows} onRowDoubleClick={(row) => {
        handleEditItem(row, true, row.Id);
      }} />
    </Box>
  );
}
